var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKillhouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;opacity:0.2;}\n\t.st2{fill:#8D7849;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Livello_6",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 1920,
    height: 1080,
    xlinkHref: "B91524B0.jpg",
    transform: "matrix(1 0 0 1 -840 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -279,
    y: -144,
    className: "st1",
    width: 1753,
    height: 1424
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Livello_4"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 1030,
    height: 1030,
    xlinkHref: "B91524B0.png",
    transform: "matrix(1 0 0 1 25 25)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,40C263.9,40,40,263.9,40,540s223.9,500,500,500s500-223.9,500-500S816.1,40,540,40z M540,968.6 c-236.7,0-428.6-191.9-428.6-428.6S303.3,111.4,540,111.4S968.6,303.3,968.6,540S776.7,968.6,540,968.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.1,
    y: 54.3,
    className: "st2",
    width: 95.7,
    height: 121.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.1,
    y: 908.6,
    className: "st2",
    width: 95.7,
    height: 121.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 908.6,
    y: 492.1,
    className: "st2",
    width: 121.4,
    height: 95.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 492.1,
    className: "st2",
    width: 121.4,
    height: 95.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M866.3,320.7c0-0.8,0-1.6,0-2.4c0.1-3-1.2-5.4-3.5-7.1c-2.9-2.2-6.1-3.6-9.8-3.6c-26.3,0-52.6,0-78.8,0 c-8.5,0-13.4,5-13.4,13.4c0,37.7,0,75.4,0,113.1c0,15.3,0,30.6,0,45.9c0,1.3-0.1,2.6-0.1,4.3c-23.1,0-45.6,0-68.3,0 c0,33.1,0,65.8,0,98.8c22.8,0,45.4,0,68.4,0c0,2,0,3.5,0,5c0,57.2,0,114.5,0,171.7c0,1.1,0,2.3,0,3.4c0.2,4.1,2.1,7,5.9,8.4 c2.2,0.8,4.6,1.3,7,1.4c27,0.1,53.9,0.1,80.9,0.1c0.7,0,1.4,0,2.1,0c3.6-0.1,6.3-1.9,8-5c1.4-2.6,1.7-5.4,1.7-8.3 C866.3,613.4,866.3,467,866.3,320.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M429.5,406c-28.6-32-57.5-63.8-86.2-95.8c-2.1-2.3-4.5-3.3-7.5-3.3c-31.8,0-63.7,0-95.5,0 c-3.2,0-6.1,1-8.7,2.7c-4.6,3-6,8.3-3.1,13c2,3.3,4.3,6.5,6.9,9.3c9.7,10.8,19.6,21.4,29.3,32.1c18.8,20.6,37.7,41,56.1,61.9 c10.5,11.9,21.2,23.6,32.4,34.9c10.4,10.4,20.9,20.8,31.4,31.1c14.1,13.9,28.2,27.7,42.4,41.5c14.5,14.1,29,28.2,43.6,42.2 c5.6,5.4,11.4,10.6,17.1,15.9c0.2-0.1,0.3-0.1,0.5-0.2c0-0.7,0-1.3,0-2c0-38.2,0-76.5,0-114.7c0-1.4-0.4-2.5-1.3-3.5 C467.8,449.4,448.8,427.6,429.5,406z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M449.9,576.4c-18.3-17.8-36.6-35.6-54.9-53.4c-2.6-2.5-5.3-5-8-7.6c-0.4,0.6-0.8,1-1.1,1.5 c-40.7,56.5-81.4,113.1-122.1,169.6c-16,22.2-31.7,44.6-47.6,66.8c-2.4,3.3-2.9,6.7-2.4,10.4c0.3,2.7,1.7,4.8,4.1,6.2 c2.6,1.6,5.3,2.5,8.4,2.5c31.8,0,63.5,0,95.3,0c2.6,0,4.9-0.6,6.8-2.3c2.3-2.1,4.7-4.2,6.6-6.7c2.7-3.5,4.9-7.4,7.4-11.1 c17.9-25.5,35.8-50.9,53.7-76.4c20.8-29.5,41.5-59,62.3-88.5c0.8-1.1,0.8-1.8-0.2-2.8C455.4,582,452.8,579.1,449.9,576.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M601.9,723.9c-4.9-4.7-10-9.2-14.8-14c-23.6-23.1-47.2-46.1-70.8-69.2c-4.2-4.1-8.4-8.1-12.9-12.5 c0,1,0,1.6,0,2.2c0,43.2,0,86.4,0,129.6c0,0.3,0,0.7,0,1c0.1,1.9,0.5,3.6,1.3,5.1c0.4,1.1,1.1,2.1,2,2.9c2.7,2.5,5.9,4,9.6,4 l-0.7-0.8c0.8,0.1,1.6,0.2,2.5,0.2c25.5,0,51.1,0,76.6,0c1.7,0,3.4-0.2,5.1-0.6c6.7-1.6,10-5.9,10-12.8c0-6.6-0.3-13.2,0.1-19.7 c0.3-5.2-1.4-9.1-5-12.5C603.8,725.9,602.9,724.9,601.9,723.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M676.8,483.6h-67.1c0-54.3,0-108.5,0-162.8c0-3.5-1-6.5-2.8-9.4c-1.9-3-4.7-4.5-8.3-4.5 c-27.7,0-55.4,0-83.1,0c-7,0-12.1,5.1-12.1,12.1c0,95.4,0,190.9,0,286.3c0,0.4-0.1,0.8,0,1.2c0.2,0.6,0.3,1.3,0.8,1.8 c10.4,10.2,20.8,20.4,31.2,30.6c20.6,20,41.2,40.1,61.8,60.1c4,3.8,8,7.6,12.1,11.4c0.2-0.1,0.3-0.1,0.5-0.2c0-0.7,0-1.5,0-2.2 c0-41.4,0-82.8,0-124.3h0.6v95.8c0-30.7,0-61.5,0-92.2c0-1.2,0.1-2.3,0.1-3.6h66.4v-0.5c0,0,0,0,0,0c0.6-5.1,0.5-74.3,0-93.9 V483.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKillhouse);
export default __webpack_public_path__ + "static/media/killhouse.df3df165d2d847e13dd370310d360d9f.svg";
export { ForwardRef as ReactComponent };